import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import { Container, ModalContainer } from '../BaseModal';
import { BodyLarge, TitleLarge } from '../Texts';
import LoadingSpinner from '../LoadingSpinner';

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 16px;
`;

const BRIDGE_KYC_CALLBACK = 'BRIDGE_KYC_CALLBACK';

const BridgeKycCallback = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const kycLinkId = searchParams.get('kyc_link_id');
    const error = searchParams.get('error');

    if (kycLinkId) {
      // Success - send the KYC link ID back to parent window
      const message = {
        type: BRIDGE_KYC_CALLBACK,
        success: true,
        kycLinkId,
      };

      if (window.parent && window.parent !== window) {
        window.parent.postMessage(message, '*');
      }
    } else if (error) {
      // Error case
      const message = {
        type: BRIDGE_KYC_CALLBACK,
        success: false,
        error,
      };

      if (window.parent && window.parent !== window) {
        window.parent.postMessage(message, '*');
      }
    } else {
      // No params - something went wrong
      const message = {
        type: BRIDGE_KYC_CALLBACK,
        success: false,
        error: 'No kyc_link_id received',
      };

      if (window.parent && window.parent !== window) {
        window.parent.postMessage(message, '*');
      }
    }
  }, [searchParams]);

  return (
    <Container>
      <ModalContainer>
        <LoadingContainer>
          <LoadingSpinner />
          <TitleLarge>Processing KYC Verification</TitleLarge>
          <BodyLarge>
            Please wait while we complete your verification...
          </BodyLarge>
        </LoadingContainer>
      </ModalContainer>
    </Container>
  );
};

export default BridgeKycCallback;
export { BRIDGE_KYC_CALLBACK };
